// Global store mode. While TRUE, the whole shop runs as PRE-ORDER (reserve now,
// ships when Printful fulfillment goes live). Flip to false to enable normal
// buy-now fulfillment once Printful is connected.
export const PREORDER_MODE = true;
export const PREORDER_NOTE =
  "Pre-order era — reserve your pieces now, they ship the moment production drops (just a few days out).";
